import { render, staticRenderFns } from "./OrderAddressModal.vue?vue&type=template&id=f366f342&"
import script from "./OrderAddressModal.vue?vue&type=script&lang=js&"
export * from "./OrderAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports